var _circle, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotTesting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 84.5,
    fill: "#FAFAFA",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 49C36 45.6863 38.6863 43 42 43H100C103.314 43 106 45.6863 106 49V74.931C106 78.2447 103.314 80.931 100 80.931H63.7325C61.7959 80.931 60.0703 82.1536 59.428 83.9806L59.2339 84.5328C57.8017 88.6073 51.9619 88.3728 50.8609 84.1966C50.3536 82.2721 48.6131 80.931 46.6228 80.931H42C38.6863 80.931 36 78.2447 36 74.931V49Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135 97C135 93.6863 132.314 91 129 91H71C67.6863 91 65 93.6863 65 97V122.931C65 126.245 67.6863 128.931 71 128.931H107.268C109.204 128.931 110.93 130.154 111.572 131.981L111.766 132.533C113.198 136.607 119.038 136.373 120.139 132.197C120.646 130.272 122.387 128.931 124.377 128.931H129C132.314 128.931 135 126.245 135 122.931V97Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.335 94C130.335 91.0536 127.946 88.665 125 88.665H67C64.0536 88.665 61.665 91.0536 61.665 94V119.931C61.665 122.877 64.0536 125.266 67 125.266H103.268C105.486 125.266 107.464 126.667 108.199 128.76L108.393 129.312C109.608 132.769 114.562 132.57 115.496 129.027C116.08 126.811 118.085 125.266 120.377 125.266H125C127.946 125.266 130.335 122.877 130.335 119.931V94Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.665 46C31.665 43.0536 34.0536 40.665 37 40.665H95C97.9464 40.665 100.335 43.0536 100.335 46V71.931C100.335 74.8775 97.9464 77.266 95 77.266H58.7325C56.5136 77.266 54.5365 78.6668 53.8007 80.7601L53.6066 81.3123C52.3916 84.7685 47.4379 84.5696 46.504 81.0271C45.9196 78.8106 43.9151 77.266 41.6228 77.266H37C34.0536 77.266 31.665 74.8775 31.665 71.931V46Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.33
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 50,
    width: 35.4836,
    height: 3.94262,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 35.4836,
    height: 3.94262,
    transform: "matrix(-1 0 0 1 118.369 98)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 64.4561,
    width: 20.3702,
    height: 3.94262,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3702,
    height: 3.94262,
    transform: "matrix(-1 0 0 1 118.369 112.456)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82.4263,
    y: 50,
    width: 3.94262,
    height: 3.94262,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.94262,
    height: 3.94262,
    transform: "matrix(-1 0 0 1 78.9424 98)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67.3125,
    y: 64.4561,
    width: 19.056,
    height: 3.94262,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 19.056,
    height: 3.94262,
    transform: "matrix(-1 0 0 1 94.0566 112.456)",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotTesting);
export default __webpack_public_path__ + "static/media/botTesting.cfa9732f.svg";
export { ForwardRef as ReactComponent };